export default __webpack_public_path__ + "static/The Adventure_image 1@2x-233ed8342615b662a814cf0574987128.jpg";